export default __webpack_public_path__ + "static/media/10.4b040f0c.mp3";